import { BinaryWriter } from "../binary.js";
import { CombatStance, DEFAULT_STANCE, isCombatStance } from "../constants.js";
import { ClientOp } from "../opcodes.js";
export function encodeStance(packet, writer = new BinaryWriter(2)) {
    writer.u8(ClientOp.Stance).u8(packet.stance);
    return writer;
}
/**
 * Postura fora do domínio vira a padrão em vez de derrubar a conexão.
 *
 * É a mesma disciplina do `decodeStats` com a vocação: o campo tem três valores válidos de um
 * byte inteiro de espaço, e um cliente de versão diferente mandando o quarto é a situação
 * normal de um servidor que já atualizou. O que ele recebe é o combate de sempre, e não um
 * `kick`.
 */
export function decodeStance(reader) {
    const raw = reader.u8();
    return { stance: isCombatStance(raw) ? raw : DEFAULT_STANCE };
}
//# sourceMappingURL=stance.js.map